import { html } from 'lit-html';
import { repeat } from 'lit-html/directives/repeat';
import { ProductApi } from '../../../api/archive/product/product-api.js';
import { IVariantShortInfo } from '../../../api/archive/product/interfaces/i-variant-short-info.js';
import { IVariantShortInfoResponse } from '../../../api/archive/product/interfaces/i-variant-short-info-response.js';
import { TilesVariantSelectorBase } from "./tiles-variant-selector-base.js";
import { IVariant } from './variant-selector-base.js';
import { createElementFromHTML } from '../../../utils/dom_tools.js';

export class RelImagesTilesVariantSelectorV2Outlet extends TilesVariantSelectorBase {
    private _productApi: ProductApi = new ProductApi();
    private _variantsShortInfo: IVariantShortInfoResponse;
    private _regularCaptionDivElement: HTMLDivElement;
    private _regularSelectorDivElement: HTMLDivElement;
    private _outletCaptionDivElement: HTMLDivElement;
    private _outletSelectorDivElement: HTMLDivElement;

    protected template = () => html`
        <div class="c-relimgtilesvariant2-term-definition ts-regular-caption">
            <label class="js-select-variant-label">${this.variantSelectorData.variants.length > 1 ? this.variantSelectorData.labels.select : '' } ${this.variantSelectorData.variantTypeName}</label>
        </div>
        <div class="c-relimgtilesvariant2-list ts-regular-selector">
        ${repeat(this.variantSelectorData.variants, (variant: IVariant) => html`
            <button type="button" class="c-relimgtilesvariant2-option js-variant" data-variantid="${variant.id}">
                <figure class="c-relimgtilesvariant2-image-container">
                ${variant.image
                    ? html`<img src="${variant.image.thumbnailUrl}" alt="${variant.image.title}" title="${variant.id}" class="c-relimgtilesvariant2-image" width="${variant.image.thumbnailDisplayWidth}" height="${variant.image.thumbnailDisplayHeight}"/>`
                    : html`<img src="${this.variantSelectorData.defaultArchiveImage}" class="c-relimgtilesvariant2-image" width="${this.variantSelectorData.thumbnailImage.width}" height="${this.variantSelectorData.thumbnailImage.height}"/>`
                }
                    <div class="c-relimgtilesvariant2-unavailable-text js-unavailable-text-container" style="display:none;">
                        <span class="c-relimgtilesvariant2-unavailable-text-label js-unavailable-text"></span>
                    </div>
                </figure>
                <div class="c-relimgtilesvariant2-name"><span>${variant.name}</span></div>
            </button>
        `)}
        </div>
        <div class="c-relimgtilesvariant2-term-definition ts-outlet-caption">
            <label>Outlet / <span class="js-select-variant-label">${this.variantSelectorData.variants.length > 1 ? this.variantSelectorData.labels.select : '' } ${this.variantSelectorData.variantTypeName}</span></label>
        </div>
        <div class="c-relimgtilesvariant2-list ts-outlet-selector">
        </div>
    `;

    protected getDataBeforeRender() {
        const self = this;

        const result = {
            variantTypeName: this.variantType.name.toLowerCase(),
            variants: this.sortVariants(this.selectorContainerElement, this.variantType.variants, this.product),
            labels: { select: this.translations.get('selectVariantPrefix'), changeSelection: this.translations.get('changeSelectionVariantPrefix') },
            defaultArchiveImage: '\\viewimage.aspx?imageid=0&width=' + this.product.thumbnailImageWidth + '&' + this.product.thumbnailImageMode,
            thumbnailImage: {
                width: this.product.thumbnailImageWidth,
                height: this.product.thumbnailImageWidth
            }
        };

        if (this.product.relatedImages && this.product.relatedImages.length > 0) {
            result.variants.forEach(function (variant: any) {
                const variantName = typeof (variant.name.normalize) === 'function' ? variant.name.normalize() : variant.name;
                const variantNameRegex = RegExp(self.product.variantRelImageMatchRegExp.replace('VARIANTNAME', variantName), 'gi');

                var relatedImage = self.product.relatedImages.find(function (relImg) {
                    var imageName = typeof (relImg.title.normalize) === 'function' ? relImg.title.normalize() : relImg.title;
                    return variantNameRegex.test(imageName);
                });

                if (relatedImage) {
                    variant.image = relatedImage;
                }
            });
        }

        return result;
    }

    protected processAfterRender(): void {
        super.processAfterRender();
        const self = this;

        this._regularCaptionDivElement = this.selectorContainerElement.querySelector('.ts-regular-caption') as HTMLDivElement;
        this._regularCaptionDivElement.style.display = 'none';
        this._regularSelectorDivElement = this.selectorContainerElement.querySelector('.ts-regular-selector') as HTMLDivElement;
        this._regularSelectorDivElement.style.display = 'none';
        this._outletCaptionDivElement = this.selectorContainerElement.querySelector('.ts-outlet-caption') as HTMLDivElement;
        this._outletCaptionDivElement.style.display = 'none';
        this._outletSelectorDivElement = this.selectorContainerElement.querySelector('.ts-outlet-selector') as HTMLDivElement;
        this._outletSelectorDivElement.style.display = 'none';

        if(this.loadAdditionalInfo){
            this._productApi.getVariantsShortInfo(this.product.productId).then((variantsShortInfo) => {
                self._variantsShortInfo = variantsShortInfo;
                self._proccessOutletVariants();
            });
        } else {
            self._proccessOutletVariants();
        }
    }

    private _isOutlet(variantId: number): boolean {
        if(!this._variantsShortInfo || this._variantsShortInfo.variantShortInfoList.length === 0){
            return false;
        }

        return this._variantsShortInfo.variantShortInfoList.some((v: IVariantShortInfo) => v.variantValues.some(value => value === variantId) && v.isOutlet);
    }

    private _isOutletVariantsExists(): boolean {
        if(!this._variantsShortInfo || this._variantsShortInfo.variantShortInfoList.length === 0){
            return false;
        }

        return this._variantsShortInfo.variantShortInfoList.some((v: IVariantShortInfo) => v.isOutlet);
    }

    private _proccessOutletVariants() {
        this._regularCaptionDivElement.style.removeProperty('display');
        this._regularSelectorDivElement.style.removeProperty('display');

        if(!this._isOutletVariantsExists()){
            this.selectorContainerElement.removeChild(this._outletCaptionDivElement);
            this.selectorContainerElement.removeChild(this._outletSelectorDivElement);
        }

        this._regularSelectorDivElement.querySelectorAll('button').forEach((variantButton: HTMLButtonElement) => {
            const variantId = parseInt(variantButton.getAttribute('data-variantid'));
            if(this._isOutlet(variantId)){
                const outletVariantButton = this._regularSelectorDivElement.removeChild(variantButton);
                this._outletSelectorDivElement.appendChild(outletVariantButton);
            }
            const variantShortInfo = this._variantsShortInfo?.variantShortInfoList.find(variantShortInfo => variantShortInfo.variantValues.includes(variantId));
            if(variantShortInfo && variantShortInfo.discountPercent > 0){
                const figure = variantButton.querySelector("figure");
                if(figure){
                    const percentSpan = createElementFromHTML(`<span class="c-relimgtilesvariant2-discount">-${variantShortInfo.discountPercent}%</span>`);
                    figure.appendChild(percentSpan)
                };
            }
        });

        this._outletCaptionDivElement.style.removeProperty('display');
        this._outletSelectorDivElement.style.removeProperty('display');
    }
}
